import React, { Component } from 'react';
import { Modal } from 'reactstrap';

export default class ModalEditNameOfNotLogin extends Component {
  constructor(props) {
    super(props);
    this.state = { userName: props.initialName || localStorage.getItem('user_temp_of_not_login') || '' };
  }

  componentDidUpdate(prevProps) {
    if (this.props.isOpen && !prevProps.isOpen) {
      this.setState({ userName: this.props.initialName || localStorage.getItem('user_temp_of_not_login') || '' });
    }
  }

  save = async () => {
    const { userName } = this.state;
    if (!userName.trim()) return;
    const email = localStorage.getItem('email_temp_of_not_login') || '';
    localStorage.setItem('user_temp_of_not_login', userName);
    if (this.props.onSave) await this.props.onSave(userName, email);
    this.props.togglePopup();
  }

  render() {
    const { isOpen, togglePopup } = this.props;
    const email = localStorage.getItem('email_temp_of_not_login') || '';
    const { userName } = this.state;

    return (
      <>
      <style>{`.modal-edit-name-not-login .modal-content { background: transparent !important; border: none !important; box-shadow: none !important; }`}</style>
      <Modal
        isOpen={isOpen}
        toggle={() => togglePopup()}
        className="modal-dialog-centered w-fit-content m-auto modal-style modal-edit-name-not-login"
        modalClassName="modal-second"
      >
        <div style={{background:'#1a1a1a',color:'#fff',borderRadius:'16px',boxShadow:'0 20px 48px rgba(0,0,0,.6)',padding:'32px 28px 24px',maxWidth:'400px',width:'calc(100vw - 48px)',textAlign:'center',fontFamily:'sans-serif',position:'fixed',top:'50%',left:'50%',transform:'translate(-50%,-50%)',zIndex:9999}}>
          <p style={{fontSize:'15px',lineHeight:'1.7',margin:'0 0 20px',fontWeight:'500',color:'#fff'}}>
            登録済みの名前を変更
          </p>
          <div style={{marginBottom:'12px',textAlign:'left'}}>
            <div style={{display:'flex',alignItems:'center',background:'rgba(255,255,255,.08)',borderRadius:'10px',padding:'8px 12px',marginBottom:'8px'}}>
              <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{marginRight:'10px',opacity:0.8,flexShrink:0}}><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
              <input
                style={{background:'transparent',border:'none',outline:'none',color:'#fff',fontSize:'14px',width:'100%'}}
                placeholder='taro yamada'
                value={userName}
                onChange={(e) => this.setState({ userName: e.target.value })}
              />
            </div>
            <div style={{display:'flex',alignItems:'center',background:'rgba(255,255,255,.08)',borderRadius:'10px',padding:'8px 12px',opacity:0.6}}>
              <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{marginRight:'10px',opacity:0.8,flexShrink:0}}><rect x="2" y="4" width="20" height="16" rx="2"/><polyline points="2,4 12,13 22,4"/></svg>
              <input
                style={{background:'transparent',border:'none',outline:'none',color:'#fff',fontSize:'14px',width:'100%'}}
                value={email}
                readOnly
              />
            </div>
          </div>
          <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginTop:'16px'}}>
            <div style={{display:'flex',gap:'12px'}}>
              <a href='/akapon_signup' style={{color:'rgba(255,255,255,.6)',fontSize:'13px',textDecoration:'underline'}} target='_blank'>新規登録</a>
              <a href='/signin' style={{color:'rgba(255,255,255,.6)',fontSize:'13px',textDecoration:'underline'}} target='_blank'>ログイン</a>
            </div>
            <button
              type="button"
              disabled={!userName.trim()}
              onClick={() => this.save()}
              style={{padding:'10px 20px',border:'none',borderRadius:'10px',background:!userName.trim()?'rgba(255,255,255,.2)':'#e60c11',color:'#fff',fontSize:'14px',fontWeight:'700',cursor:!userName.trim()?'not-allowed':'pointer',boxShadow:!userName.trim()?'none':'0 4px 12px rgba(230,12,17,.4)'}}
            >登録名を変更する</button>
          </div>
        </div>
      </Modal>
      </>
    );
  }
}
